<div *ngIf="settings">
    <nb-card>
        <nb-card-header>
            {{titolo}}
        </nb-card-header>

        <nb-card-body>
            <ng2-smart-table
                [settings]="settings"
                [source]="source"
                (edit)="onEdit($event)"
                (create)="onCreate($event)"
                (delete)="onDelete($event)"
                (createConfirm)="onCreateConfirm($event)"
                (editConfirm)="onEditConfirm($event)"
                (deleteConfirm)="onDeleteConfirm($event)"
                (userRowSelect)="onUserRowSelect($event)"
            >
            </ng2-smart-table>
        </nb-card-body>
    </nb-card>
</div>
